module.exports = __webpack_public_path__ + "img/pic-contactus-pc.b029024.png";